import { createAsyncThunk } from "@reduxjs/toolkit";
import DashboardAPI, {
  IDashboardRequestPayload,
  IGetDashboardResponse,
} from "../../../api/dashboard";
import { RootState } from "../../../app/store";

export const fetchDashboardMetricsThunk = createAsyncThunk<
  IGetDashboardResponse,
  { params?: IDashboardRequestPayload; force?: boolean } | undefined,
  { state: RootState; rejectValue: string }
>(
  "dashboard/fetchMetrics",
  async (arg, { rejectWithValue }) => {
    try {
      return await DashboardAPI.getMetrics(arg?.params);
    } catch (error: any) {
      return rejectWithValue(
        error.message || "Failed to fetch dashboard metrics",
      );
    }
  },
  {
    condition(arg, { getState }) {
      const state = getState().dashboardData;
      const force = arg?.force;

      if (force) return true;
      if (state.data) return false;
      return true;
    },
  },
);
